var React = require('react');

function Doctorlogic (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M811 327.9H710.7v345H811c100.4 0 181.9-75.8 181.9-169.3v-6.3c0-93.5-81.5-169.4-181.9-169.4z","key":0}),React.createElement("path",{"d":"M673.8 810.1V709.8H328.9v100.3c0 100.4 75.8 181.9 169.3 181.9h6.3c93.4 0 169.3-81.5 169.3-181.9z","key":1}),React.createElement("path",{"d":"M191.5 672.9h100.3v-345H191.5C91.1 327.9 9.6 403.7 9.6 497.3v6.3c0 93.4 81.5 169.3 181.9 169.3z","key":2}),React.createElement("path",{"d":"M328.8 190.4v100.3h344.9V190.4C673.7 90 597.9 8.6 504.4 8.6h-6.3C404.7 8.5 328.8 90 328.8 190.4z","key":3}),React.createElement("path",{"d":"M328.7 327.9h344.9v345H328.7z","key":4})]);
}

Doctorlogic.defaultProps = {"id":"Layer_1","viewBox":"0 0 1000 1000"};

module.exports = Doctorlogic;

Doctorlogic.default = Doctorlogic;
